import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'antd'
import './index.css'

interface ButtonPurpleLinkProps {
  buttonText?: string;
  classes?: string;
  to?: string;
  holderStyles?: React.CSSProperties;
  buttonStyles?: React.CSSProperties;
}

const ButtonPurpleLink: React.FC<ButtonPurpleLinkProps> = ({
  buttonText = 'Got it',
  classes = '',
  to = '/',
  holderStyles = {},
  buttonStyles = {},
}) => {
  return (
    <div className="button-holder-purple-link" style={holderStyles}>
      <Link to={to}>
        <Button className={classes} style={buttonStyles}>
          <span>{buttonText}</span>
        </Button>
      </Link>
    </div>
  )
}

export default ButtonPurpleLink
